import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  CANCEL_RESTO_BILL,
  getAuthSession,
  isOtherRoleAllowed,
  OTHER_ADMIN_RIGHTS,
  SUCCESS,
} from "../../../constants/constant";
import { snpAxios } from "../../global/api";
import DialogBox from "../../global/DialogBox";
import DismissButton from "../../global/DismissButton";
import EnterButton from "../../global/EnterButton";
import { Box, TextField } from "../../ui";
import { isCancelledRestoBill } from "./CancelledBillDialog";

const CancelRestoBillButton = ({ billNo, billStatus, onCancelled }) => {
  const api = useSelector((state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL)?.BACKEND_BASE_URL;
  const shopHash = useSelector((state) => state.setActiveShopHashReducer.activeShopHash)?.id;
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const cancelled = isCancelledRestoBill(billStatus, billNo);

  if (!isOtherRoleAllowed(OTHER_ADMIN_RIGHTS) || !String(billNo || "").trim()) return null;

  const cancelBill = async () => {
    if (!reason.trim() || saving) return;
    setSaving(true);
    setError("");
    try {
      const response = await snpAxios.post(`${api}${CANCEL_RESTO_BILL}`, { jcJson: {
        apiToken: getAuthSession().apiToken, shopHash, billNo, reason: reason.trim(),
      } });
      if (response.data.status !== SUCCESS) throw new Error(response.data.message || "Unable to cancel bill");
      setOpen(false);
      setReason("");
      onCancelled?.();
    } catch (cancelError) {
      setError(cancelError?.response?.data?.message || cancelError.message || "Unable to cancel bill");
    } finally {
      setSaving(false);
    }
  };

  return <>
    <EnterButton variant="contained" color="error" className="cancel-bill-shine"
      disabled={cancelled || saving} onClick={() => setOpen(true)}>
      {cancelled ? "Already cancelled" : "Cancel Bill"}
    </EnterButton>
    <DialogBox showDialog={open} title="Cancel Bill" onClose={() => setOpen(false)}
      outsideClickedDismiss={false} mwidth="sm" mFullWidth
      dialogContent={<Box sx={{ width: "100%", pt: 0.5 }}>
        <TextField autoFocus required fullWidth multiline minRows={3} label="Cancellation reason"
          placeholder="Enter reason" value={reason} onChange={(event) => setReason(event.target.value)}
          error={Boolean(error) || !reason.trim()} helperText={error || "Reason is mandatory"} />
      </Box>}
      dialogActions={<>
        <DismissButton variant="contained" onClick={() => setOpen(false)}>Close</DismissButton>
        <EnterButton variant="contained" color="error" disabled={!reason.trim() || saving} onClick={cancelBill}>
          {saving ? "Cancelling…" : "Cancel Bill"}
        </EnterButton>
      </>}
    />
  </>;
};

export default CancelRestoBillButton;
